// ============================================
// ENEMY SYSTEM - 敵の更新（ゲームループ用）
// ============================================

import { getP5 } from '../../core/p5-instance';
import { CONFIG } from '../../config/game-config';
import {
    getEnemies,
    getPlayer,
    getWave,
    setCombo
} from '../../store';
import { setLastAnimatedCombo, setComboAnimTimer } from '../../store/animation-state';
import { getDiffConfig } from '../../utils/helpers';
import { updateEnemy } from '../../features/enemy/enemy';
import { updateBoss } from '../../features/enemy/boss';

/**
 * updateEnemies() - 敵の更新
 */
export function updateEnemies(dt: number): void {
    const p = getP5();
    const enemies = getEnemies();
    const player = getPlayer();
    if (!player) {
        return;
    }

    const wave = getWave();
    const diffCfg = getDiffConfig();
    const currentSpeed = (CONFIG.enemyBaseSpeed + wave * 0.3) * diffCfg.enemySpeedMult;

    for (let i = enemies.length - 1; i >= 0; i--) {
        const enemy = enemies[i];
        const enemySpeed = currentSpeed * (enemy.speedMult || 1.0);

        if (enemy.type === 'boss') {
            updateBoss(enemy, dt);
        } else {
            updateEnemy(enemy, enemySpeed, dt, i);
        }

        // 画面外消去 (生存確認は各 update 関数内で行われる場合もあるが、共通処理として残す)
        // updateEnemy/updateBoss 内で splice された可能性を考慮
        const currentEnemy = enemies[i];
        if (currentEnemy && currentEnemy.y > p.height + 50) {
            enemies.splice(i, 1);
            setCombo(0);
            setLastAnimatedCombo(0);
            setComboAnimTimer(0);
        }
    }
}
